import {roleService} from "../services/role.service";
import {roleConstants} from "../constants/role.constants";
import {history} from "../helpers/history";
import {toastr} from "react-redux-toastr";
import i18next from "i18next";

const getRoleList = () => {
    return dispatch => {
        roleService.getList()
            .then(
                (roleModel) => {
                    dispatch({type: roleConstants.ROLE_LIST_SUCCESS, roleModel});
                },
                (error) => {
                    console.log(error);
                    dispatch({type: roleConstants.ROLE_LIST_FAILURE})
                }
            )
    }
};

const getRoleById = (roleId) => {
    return dispatch => {
        roleService.getElementById(roleId)
            .then(
                (roleModel) => {
                    dispatch({type: roleConstants.ROLE_BY_ID_SUCCESS, roleModel})
                },
                (error) => {
                    console.log(error);
                    dispatch({type: roleConstants.ROLE_BY_ID_FAILURE, error})
                }
            )
    }
};

const createRole = (roleModel) => {
    return dispatch => {
        roleService.createRole(roleModel)
            .then(
                (response) => {
                    history.push(`/panel/role/edit/${response.id}`)
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const editRole = (roleModel, roleId) => {
    return dispatch => {
        roleService.editRole(roleModel)
            .then(
                () => {
                    dispatch(getRoleById(roleId));
                    console.log(roleModel);
                    toastr.info(i18next.t('role'), i18next.t('msg.edit-role', { key: roleModel.label }));
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const deleteRole = (roleId) => {
    return dispatch => {
        roleService.deleteRole(roleId)
            .then(
                () => dispatch(getRoleList()),
                (error) => console.log(error)
            )
    }
};

const clearStore = () => {
    return dispatch => {
        dispatch({type: roleConstants.ROLE_LIST_CLEAR})
    }
};


export const roleActions = {
    getRoleList,
    getRoleById,
    createRole,
    editRole,
    deleteRole,
    clearStore
};
